import {
  MODAL_SHOW,
  MODAL_HIDE,
  MODAL_HIDE_ALL,
} from 'actions/modal';

const initialState = {
  stack: []
};

const modal = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_SHOW: {
      let next = {...state};
      next.stack = (state.stack || initialState.stack).slice();
      next.stack.push({...action.payload});
      return next;
    }
    case MODAL_HIDE: {
      let next = {...state};
      next.stack = (state.stack || initialState.stack).slice();

      if (next.stack.length > 0)
        next.stack.pop();

      return {...next};
    }
    case MODAL_HIDE_ALL:{
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default modal;


// WEBPACK FOOTER //
// ./src/reducers/modal.js